// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading-overlay__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio, onClickCallback) {
  const overlay = createOverlay(image);
  overlay.onclick = () => {
    overlay.remove();
    if (onClickCallback) onClickCallback();
  };
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

function enableZoomOnHoverOnly(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover_only');
  images.forEach((image) => {
    function attachEnter() {
      image.onmouseenter = (event) => {
        const modalButton = image.closest('modal-opener')?.querySelector('.product__media-toggle');
        magnify(image, zoomRatio, () => {
          // Temporarily detach to prevent the flash re-trigger when the overlay
          // disappears and the browser synthesizes a mouseenter on the img below.
          image.onmouseenter = null;
          if (modalButton) modalButton.click();
          setTimeout(attachEnter, 300);
        });
        moveWithHover(image, event, zoomRatio);
      };
    }
    attachEnter();
  });
}

enableZoomOnHover(2);
enableZoomOnHoverOnly(1.5);
